/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const rebuildClipsResponseDataSchema = z.object({
  scanned: z.number(),
  enqueued: z.number(),
  duplicate: z.number(),
  skipped: z.number(),
  total: z.number().default(0),
  nextCursor: z.string().optional(),
});

export type IRebuildClipsResponseData = z.infer<typeof rebuildClipsResponseDataSchema>;

export const rebuildClipsResponseSchema = createApiResponseSchema(
  rebuildClipsResponseDataSchema,
) as z.ZodSchema<IAPI<IRebuildClipsResponseData>>;

export type IRebuildClipsResponse = IAPI<IRebuildClipsResponseData>;
